import { useFeeChargeBreakdownTableProps } from "features/fees/FeeChargeBreakdownTableProps";
import { PostedFeeChargeOutletContext } from "features/fees/posted/PostedFeeChargeOutletContext";
import { useFeeChargeEventBasisBreakdownByUseRetrieveSuspense } from "gen/endpoints/fee-charge-event/fee-charge-event";
import React from "react";
import { useOutletContext } from "react-router";
import { DataTable } from "shared/components/table/data/DataTable";

export const PostedFeeChargeByUseTab: React.FC = () => {
  const { fundFamilyId, feeChargeEventId, isEqualizedView } =
    useOutletContext<PostedFeeChargeOutletContext>();
  const { data } = useFeeChargeEventBasisBreakdownByUseRetrieveSuspense(
    fundFamilyId,
    feeChargeEventId,
    {
      is_equalized_view: isEqualizedView || undefined,
    },
  );
  const tableProps = useFeeChargeBreakdownTableProps(fundFamilyId);
  return <DataTable data={data} {...tableProps} />;
};
